import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes } from "react-router-dom";
import { PrivateRoutes } from "./privateRoutes";
export var AppRouter = function () {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/*", element: _jsx(PrivateRoutes, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/login", replace: true }) })] }));
};
